<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <p>Für die Ausstellung „Open House“ des Vitra Design Museums, wurde der begehbare Konzeptbau und Ausstellungspavillon CORPFORM entwickelt. Im Rahmen der ENTRY 2006 in der Zeche Zollverein in Essen wurde das Konzeptgebäude erstmals gezeigt.
                Es zeigt Analogien zu lebenden Organismen und bionische Prinzipien auf. Die Adaptivität bzw. Anpassungsfähigkeit stellt die Haupteigenschaft des Experimentalbaus dar.
                Insbesondere die Gebäudehülle und -tragstruktur des Baus passen sich an wechselnde äußere Klima- und Witterungsbedingungen an. Unterschiedliche Materialien wie Textilien, Folien, Keramiken, Glas und Kunststoffe werden mit Hilfe von mehrlagigen Zell- oder Layersystemen in das integrative Gesamtsystem eingebunden.
            </p>
            <br>
            <br>
            <p class="font-semibold">Ausstellungen</p>
            <ul class="list-disc p-5">
                <li>Entry 2006 Open House Zeche Zollverein Essen</li>
                <li>Designcenter Pasadena</li>
                <li>Warschau Designzentrum</li>
                <li>Designzentrum Belfast</li>
                <li>Designzentrum Oslo</li>
            </ul>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf und Realisierung</p>
            <p>Markus Holzbach mit Formorf</p>
        </span>

    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/Bild 12 Vitra-Corpform-1 Entry WAZ.jpg' ),
                require( '@/assets/img/pc/Bild 14 Vitra Corpform-2.jpg' ),
                require( '@/assets/img/pc/IMG_5418.jpg' ),
                require( '@/assets/img/pc/Bild 13 Pneumatische Tragstruktur Corpform.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>